import React from "react";

const FatReport = ({ state, onChange, onAddRow, onRemoveRow }) => {
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-12 ">
          <div className="appraisal-report-table-responsive">
            <table className="assessment-table" cellSpacing={0}>
              <tbody>
                <tr>
                  <td className="hd-s2 pd10" colSpan={6}>
                    <p>1. Major inspections and schedule of this month</p>
                  </td>
                </tr>

                {/* Header Row */}
                <tr>
                  <td className="td-s1">
                    <p className="s1">#</p>
                  </td>
                  <td className="td-s1">
                    <p className="s1">Inspection</p>
                  </td>
                  <td className="td-s1">
                    <p className="s1">Result</p>
                  </td>
                  <td className="td-s1">
                    <p className="s1">Evaluation</p>
                  </td>
                  <td className="td-s1">
                    <p className="s1">Feedback</p>
                  </td>
                  <td className="td-s1">
                    <p className="s1">Action</p>
                  </td>
                </tr>

                {/* Dynamic Rows */}
                {state.map((row, index) => (
                  <tr key={index}>
                    <td className="td-s1 text-center">{index + 1}</td>

                    {/* Inspection */}
                    <td className="tb-input-value">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Inspection"
                        name="inspection"
                        value={row.inspection.value}
                        onChange={(e) => onChange(e, index)}
                      />
                    </td>

                    {/* Result */}
                    <td className="tb-input-value">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Result"
                        name="result"
                        value={row.result.value}
                        onChange={(e) => onChange(e, index)}
                      />
                    </td>

                    {/* Evaluation */}
                    <td className="tb-input-value">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Evaluation"
                        name="evaluation"
                        value={row.evaluation.value}
                        onChange={(e) => onChange(e, index)}
                      />
                    </td>

                    {/* Feedback */}
                    <td className="tb-input-value">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Feedback"
                        name="feedback"
                        value={row.feedback.value}
                        onChange={(e) => onChange(e, index)}
                      />
                    </td>

                    {/* Remove Row */}
                    <td className="tb-input-value text-center">
                      <button
                        type="button"
                        style={{
                          backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                          borderColor: "#2b5a7e"
                        }}
                        className="btn btn-danger btn-sm"
                        onClick={() => onRemoveRow(index)}
                      >
                        Remove
                      </button>
                    </td>
                  </tr>
                ))}

                {/* Add Row */}
                <tr>
                  <td colSpan={6}>
                    <button
                      type="button"
                      className="btn btn-primary btn-sm ms-2"
                      style={{
                        backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                        borderColor: "#2b5a7e"
                      }}
                      onClick={onAddRow}
                    >
                      + Add Row
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FatReport;
